import { render, staticRenderFns } from "./ThePriceSection.vue?vue&type=template&id=ce93874e&scoped=true&name=the-price-section&"
import script from "./ThePriceSection.vue?vue&type=script&lang=js&"
export * from "./ThePriceSection.vue?vue&type=script&lang=js&"
import style0 from "./ThePriceSection.vue?vue&type=style&index=0&id=ce93874e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce93874e",
  null
  
)

/* custom blocks */
import block0 from "./ThePriceSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports